import { ExpandSVG } from 'src/components/Icons/Basic'
import styled from 'styled-components/macro'

export const AutomaticEvidenceToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  white-space: nowrap;
`

export const ColumnsMenuContainer = styled.div`
  display: flex;
  position: relative;
  padding: 12px;
  flex-direction: column;
  gap: 8px;
`

export const ExpandEvidenceIcon = styled(ExpandSVG)`
  cursor: pointer;
  height: 14px;
  width: 14px;
`
